import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Input, Button, Icon, Alert, Row, Col, message } from 'antd';
import Ink from 'react-ink';

import {
  translationInsert,
  translationUpdate
} from '../../../modules/translation';

const FormItem = Form.Item;

class TranslationDetails extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: false,
			message: null
		}
	}
	
	handleSubmit = e => {
		e.preventDefault();

		const { data } = this.props;

		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.setState({ loading: true });

				if (!this.props.data) {
					this.props.translationInsert(values).then( 
						(res) => {
							message.success('Translation successfully added!');
							this.setState({ loading: false, message: null });
							this.props.form.resetFields();
							this.props.callback();
						},
						(err) => {
							this.setState({ loading: false, message: `Can't get through. Please make sure input is valid or contact the administrator.` }); 
						}
					);
				}
				else {
				
				this.props.translationUpdate(values, data._id).then( 
					(res) => {
						message.success('Translation info successfully updated!');
						this.setState({ loading: false, message: null });
						this.props.callback();
					},
					(err) => {
						this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` }); 
					}
				);
			}
			}
		});
	}

	render() {
		
		const { loading, message } = this.state;
		const { getFieldDecorator } = this.props.form;

		const { data } = this.props;
		
		return (
			<Form onSubmit={this.handleSubmit} className="ownForm">
				{ (message) ? <Alert message={message} type="error" style={{ marginBottom: '20px' }} showIcon /> : ""}

				<FormItem
					label="Translation Id"
				>
					{ getFieldDecorator('translationId', {
						rules: [ { required: true, message: 'Please input translation Id!' } ],
						initialValue: (data && data.translationId) ? data.translationId : ""
					})(
					<Input />
					)}
				</FormItem>

				<Row gutter={16}>
					<Col span={24}>
						<FormItem
							label="tc"
							className="lessMarginBtm"
						>
							{getFieldDecorator('tc', {
								initialValue: (data && data.tc) ? data.tc : "" 
							})(
							<Input />
							)}
						</FormItem>
					</Col>
				</Row>

        <Row gutter={16}>
					<Col span={24}>
						<FormItem
							label="sc"
							className="lessMarginBtm"
						>
							{getFieldDecorator('sc', {
								initialValue: (data && data.sc) ? data.sc : "" 
							})(
							<Input />
							)}
						</FormItem>
					</Col>
				</Row>
			
        <Row gutter={16}>
					<Col span={24}>
						<FormItem
							label="en"
							className="lessMarginBtm"
						>
							{getFieldDecorator('en', {
								initialValue: (data && data.en) ? data.en : "" 
							})(
							<Input />
							)}
						</FormItem>
					</Col>
				</Row>

				<FormItem 
					className="noMarginBtm"
				>
					<Button type="primary" htmlType="submit" disabled={loading} style={{ width: '100%' }}><Ink /><Icon type="arrow-right" /> Submit</Button>
				</FormItem>
			</Form>
		);
	}
}

const WrappedTranslationDetailsModal  = Form.create()(TranslationDetails);

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		translationInsert,
		translationUpdate
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedTranslationDetailsModal);